import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import heroBg from "./../../assets/our-journey-banner.jpg";
import journeyFirst from "./../../assets/our-journey-first.jpg";
import journeySecond from "./../../assets/our-journey-second.jpg";
import journeyThird from "./../../assets/our-journey-third.jpg";
import journeyFour from "./../../assets/our-journey-four.jpg";
import journeyFive from "./../../assets/our-journey-five.jpg";

import "./style.scss";

gsap.registerPlugin(ScrollTrigger);

const introContent = {
  subtitle: "Since 1991",
  heading: "Experience built over decades. Ready in minutes.",
  subHeading: "35 Years of Delivering When Time Matters.",
  description: [
    "Esquire has been moving shipments and solving logistics challenges since 1991.",
    "Routes, technology and customer requirements have changed over the decades. The responsibility has not: make the right decisions, coordinate every critical stage and keep the shipment moving.",
  ],
};

const journeyData = [
  {
    id: "journey-1",
    number: "01",
    year: "1991 - 1998",
    text: "Esquire has been moving shipments and solving logistics challenges since 1991.",
    image: journeyFirst,
  },
  {
    id: "journey-2",
    number: "02",
    year: "1998 - 2005",
    text: "Routes, technology and customer requirements have changed over the decades.",
    image: journeySecond,
  },
  {
    id: "journey-3",
    number: "03",
    year: "2005 - 2012",
    text: "The responsibility has not: make the right decisions, coordinate every critical stage and keep the shipment moving.",
    image: journeyThird,
  },
  {
    id: "journey-4",
    number: "04",
    year: "2012 - 2019",
    text: "Experience built over decades. Ready in minutes.",
    image: journeyFour,
  },
  {
    id: "journey-5",
    number: "05",
    year: "2019 - 2026",
    text: "35 Years of Delivering When Time Matters.",
    image: journeyFive,
  },
];

const OurJourneySec = () => {
  const heroSectionRef = useRef(null);
  const xScrollRef = useRef(null);
  const progressFillRef = useRef(null);

  useEffect(() => {
    const heroSection = heroSectionRef.current;
    const xScroll = xScrollRef.current;
    const progressFill = progressFillRef.current;

    if (!heroSection || !xScroll) return;

    const initHeroServices = () => {
      // Remove only triggers created for this section
      ScrollTrigger.getAll().forEach((trigger) => {
        if (trigger.trigger === heroSection) {
          trigger.kill();
        }
      });

      gsap.set(xScroll, { x: 0 });

      // Round to whole pixels so ScrollTrigger isn't fed fractional
      // widths — fractional distances are what produce the stray
      // `top: 0.4xxxpx` on the pin-spacer and the 1px flicker/gap
      // right when the section pins/unpins.
      const scrollWidth = Math.ceil(xScroll.scrollWidth);
      const viewportWidth = Math.round(window.innerWidth);
      const distance = scrollWidth - viewportWidth;

      gsap.to(xScroll, {
        x: -distance,
        ease: "none",
        scrollTrigger: {
          trigger: heroSection,
          start: "top top",
          end: "+=" + distance,
          scrub: 1,
          pin: true,
          pinType: "fixed",
          anticipatePin: 1,
          invalidateOnRefresh: true,
          onUpdate(self) {
            if (progressFill) {
              progressFill.style.width = `${self.progress * 100}%`;
            }
          },
        },
      });

      ScrollTrigger.refresh();
    };

    initHeroServices();

    window.addEventListener("resize", initHeroServices);

    return () => {
      window.removeEventListener("resize", initHeroServices);
      ScrollTrigger.getAll().forEach((trigger) => {
        if (trigger.trigger === heroSection) {
          trigger.kill();
        }
      });
    };
  }, []);

  return (
    <section className="hero-services" id="hero" ref={heroSectionRef}>
      <div className="hero-services__x-scroll" ref={xScrollRef}>
        <div
          className="hero-services__section hero-services__section-0"
          style={{ backgroundImage: `url(${heroBg})` }}
        >
          <div className="container">
            {/* <p className="hero-services__caption hero-services__caption--light">
              Since 1991
            </p> */}
            <h1 className="hero-services__title main-animated-text">
              Our Journey
            </h1>
          </div>
        </div>

        <div className="hero-services__section hero-services__section-intro">
            <div className="hero-services__intro">
            <p className="hero-services__intro-subtitle">
              {introContent.subtitle}
            </p>
            <h2 className="hero-services__intro-heading">
              {introContent.heading}
            </h2>
            <h3 className="hero-services__intro-subheading">
              {introContent.subHeading}
            </h3>
            <div className="hero-services__intro-description">
              {introContent.description.map((para, i) => (
                <p key={i}>{para}</p>
              ))}
            </div>
          </div>
          <div
            className="hero-services__image"
            style={{ backgroundImage: `url(${journeyFirst})` }}
          ></div>

        
        </div>

        {/* {journeyData.map((item, index) => (
          <div
            key={item.id}
            className={`hero-services__section hero-services__section-${
              index + 1
            }`}
            id={item.id}
          >
            <div
              className="hero-services__image"
              style={{ backgroundImage: `url(${item.image})` }}
            >
              <div className="hero-services__heading">
                <span className="hero-services__heading-number">
                  {item.number}
                </span>
                <h2 className="hero-services__heading-text">{item.year}</h2>
              </div>
            </div>

            <div className="hero-services__container">
              <p className="hero-services__text-large">{item.text}</p>
            </div>
          </div>
        ))} */}
      </div>

      <div className="hero-services__progressbar">
        <div
          className="hero-services__progressbar-fill"
          ref={progressFillRef}
        ></div>
      </div>
    </section>
  );
};

export default OurJourneySec;